import { Streamdown } from "streamdown";

interface MarkdownProps {
  children: string;
  isAnimating?: boolean;
}

export function Markdown({ children, isAnimating = false }: MarkdownProps) {
  return (
    <div className="prose prose-sm dark:prose-invert max-w-none text-sm text-foreground">
      <Streamdown isAnimating={isAnimating}>{children}</Streamdown>
    </div>
  );
}
